import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useIsPlant } from '@/entities/user';
import { useAppPrefix } from '@/shared/lib/hooks/use-app-prefix.hook';

const GlobalPrefixGuardComponent = () => {
	const { pathname, search } = useLocation();
	const navigate = useNavigate();
	const isPlant = useIsPlant();
	const prefix = useAppPrefix();

	useLayoutEffect(() => {
		if (pathname.startsWith(prefix)) return;

		navigate(`${prefix}${pathname}${search}`, { replace: true });
	}, [pathname, search, isPlant, navigate]);

	return null;
};

export default GlobalPrefixGuardComponent;
